module.exports = __webpack_public_path__ + "img/gb_03.fc88530f.png";